import React from "react";
import Icon from "react-icons-kit";
import { close } from "react-icons-kit/ionicons/close";
import AlertBox from "../UI/AlertBox/AlertBox";
import successIcon from "../../../assets/images/green-check.png";
import "../../../assets/css/components/Modal/Modal.css";

const AchPaymentModal = (props) => {
  const { modalVisibility, modalClass, modalLabel, closeModalHandler, messageContent, doneBtnId } = props
  return (
    <AlertBox
      alertVisibility={modalVisibility}
      closeAlertBoxHandler={closeModalHandler}
      backdrop={false}
      alertLabel={modalLabel}
      alertClass={modalClass}
    >
      <div className="modal-wrapper">
        <div className="text-right">
          <span onClick={closeModalHandler}>
            <Icon size={20} icon={close} />
          </span>
        </div>
        <div className="text-center mar">
          <img className="green-check" src={successIcon} alt="Success" />
        </div>
        <p className="content-modal text-center">
          <p className="btn btn-link props-message">
            {messageContent}
          </p>
        </p>
        <div className={"text-center"}>
          <button
            onClick={closeModalHandler}
            type="button"
            className="btn btn-org"
            id={doneBtnId}
          >
            Done
            </button>
        </div>
      </div>
    </AlertBox>
  );
}

export default AchPaymentModal;



// WEBPACK FOOTER //
// ./src/components/common/AchPaymentModal/AchPaymentModal.jsx